export default "__VITE_ASSET__jyQSRkvd__"